import { render, staticRenderFns } from "./MenuSideNav.vue?vue&type=template&id=f716641c&scoped=true"
import script from "./MenuSideNav.vue?vue&type=script&lang=js"
export * from "./MenuSideNav.vue?vue&type=script&lang=js"
import style0 from "./MenuSideNav.vue?vue&type=style&index=0&id=f716641c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f716641c",
  null
  
)

export default component.exports